import superagent from 'superagent'; // eslint-disable-line no-restricted-imports

function genericXhrHeadersWithCsrf() {
    const csrfMeta = document.querySelector('meta[name="csrf-token"]');
    const token = csrfMeta ? csrfMeta.content : 'fake-token';
    return {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': token,
    };
}

function genericXhrHeaders() {
    return {
        'X-Requested-With': 'XMLHttpRequest',
    };
}

export function fetchHtml(url) {
    return new Promise((resolve, reject) => {
        const xhr = superagent.get(url).set('Accept', 'application/html');

        xhr.end((error, res) => {
            if (error) {
                reject({ error, url });
            } else {
                resolve(res.text);
            }
        });
    });
}

export function get(url) {
    return superagent.get(url).set(genericXhrHeaders());
}

export function putRequest(url) {
    return superagent.put(url).set(genericXhrHeadersWithCsrf());
}

export function deleteRequest(url) {
    return superagent.delete(url).set(genericXhrHeadersWithCsrf());
}

export function toggleRequest(toggleState, url) {
    if (toggleState) {
        return putRequest(url);
    }
    return deleteRequest(url);
}



// WEBPACK FOOTER //
// ./src/js/utils/xhr.js